import { Factory, ProjectActions } from '@octopus-do/octopus-project-core'
import { thunkUpdateBlockTitle } from '@store/migrationActions/thunkActions/thunkBlocksActions'
import { useGetHydratedBlocks } from '@store/migrationSelectors/blocks/useGetHydratedBlocks'
import eq from 'fast-deep-equal'

const handleChange = (previousReducerState, store) => {
  const nextState = store.getState()
  const currentReducerBlocksState = nextState.manager.project.blocks
  const currentReducerSymbolsState = nextState.manager.project.symbols
  const currentReducerState = nextState.canvas

  const { getHydratedBlockById } = useGetHydratedBlocks({
    blocks: currentReducerBlocksState,
    symbols: currentReducerSymbolsState,
    library: nextState.library.symbol,
    colors: nextState.manager.project.colors,
  })

  if (previousReducerState !== currentReducerState) {
    const {
      block: {
        ids: previousSelectedBlockIdsValue,
        selectedToEditBlockId: previousSelectedToEditBlockIdValue,
        autoCreatedBlockId: previousAutoCreatedBlockIdValue,
        editTitleValue,
      },
    } = previousReducerState

    const {
      block: {
        ids: currentSelectedBlockIdsValue,
        selectedToEditBlockId: currentSelectedToEditBlockIdValue,
      },
    } = currentReducerState

    if (
      previousSelectedToEditBlockIdValue !== currentSelectedToEditBlockIdValue
    ) {
      const block =
        currentReducerBlocksState[previousSelectedToEditBlockIdValue]

      if (!block) {
        return currentReducerState
      }

      const hydratedBlock = getHydratedBlockById(block.id)

      if (hydratedBlock.title !== editTitleValue) {
        updateBlockTitle(
          store,
          previousSelectedToEditBlockIdValue,
          editTitleValue
        )

        return currentReducerState
      }
    }

    if (
      previousSelectedBlockIdsValue.includes(previousAutoCreatedBlockIdValue) &&
      !eq(previousSelectedBlockIdsValue, currentSelectedBlockIdsValue)
    ) {
      const autoCreatedBlock =
        currentReducerBlocksState[previousAutoCreatedBlockIdValue]

      if (!autoCreatedBlock) {
        return currentReducerState
      }

      const blockModel = Factory.block.monolithic({
        id: previousAutoCreatedBlockIdValue,
        colorId: autoCreatedBlock.colorId,
      })

      if (eq(autoCreatedBlock, blockModel)) {
        if (
          currentReducerState.uploadingImage.id !==
            previousAutoCreatedBlockIdValue &&
          !currentReducerState.uploadingImage.uploading
        ) {
          deleteBlockWithDelay(store, previousAutoCreatedBlockIdValue)
        }

        return currentReducerState
      }
    }
  }

  return currentReducerState
}

const updateBlockTitle = (store, id, title) => {
  store.dispatch(thunkUpdateBlockTitle({ id, title }))
}

const deleteBlockWithDelay = (store, blockId) => {
  setTimeout(() => {
    store.dispatch(ProjectActions.blocks.delete({ ids: [blockId] }))
  }, 100)
}

export const observer = (store) => {
  let previousReducerState = store.getState().canvas
  store.subscribe(() => {
    previousReducerState = handleChange(previousReducerState, store)
  })
}
